// removed by extract-text-webpack-plugin
module.exports = {"section":"_2tMM1zl-sHbJzyi6nA6vuM_0","note":"_2n_DETZWuLVNsPT2QKMgHC_0","warn":"_3RArqYEE7Uj8q5xgQU2uWv_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58c5aafe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Users/edit/index.vue
// module id = OGIF
// module chunks = 1